import { Skeleton } from 'modules/common/components/_ui/Skeletons/Skeleton/Skeleton'

export const SponsorshipVoucherPreviewSkeleton = () => (
  <Skeleton className="mt-3 h-[120px] w-full rounded-xl" />
)
